// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"8c8b6024","118":"0d28fefa","137":"adda7625","238":"45173d36","436":"9837e6b3","439":"3f6997a6","513":"7d7d4971","582":"25d0c7ea","771":"86194f53","994":"fdd74fc6","996":"4fb6b155"}[chunkId] + ".chunk.js";
};